import React from 'react'

const ModalClose = (props) => {

    return (
        <div className="close-modal" data-dismiss="modal">
            <div className="lr">
                <div className="rl"></div>
            </div>
        </div>
    )
}

const ModalContent = (props) => {

    return (
        <div className="container">
            <div className="row">
                <div className="col-lg-8 mx-auto">
                    <div className="modal-body">
                        <h3>{props.modal.title}</h3>
                        <h4>{props.modal.subtitle}</h4>
                        <img className="portfolio-image-view img-fluid d-block mx-auto" src={props.modal.image} alt="" />
                        <button className="btn btn-primary" data-dismiss="modal" type="button">
                            <i className="fas fa-times" style={{paddingRight: '20px'}}></i><span>Chiudi</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

const Modal = (props) => {

    return (
        <div className="portfolio-modal modal fade" id="portfolioModal" tabIndex="-1" role="dialog" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                    <ModalClose />
                    <ModalContent {...props} />
                </div>
            </div>
        </div>
    )
}

export default Modal